export enum SelfRegistrationStoreSlice {
	Application = 'self-registration-application'
}
